import React from 'react';
import PropTypes from 'prop-types';
import Grid from '../components/Grid.jsx';
import Checkbox from '../components/Checkbox.jsx';

const GridCheckbox = ({ gridProps, ...props }) => {
  return (
    <Grid item {...gridProps}>
      <Checkbox {...props} />
    </Grid>
  );
};

GridCheckbox.propTypes = {
  gridProps: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.bool,
};

export default GridCheckbox;
